export const resonance = {
  resonance_title: 'Aplicación Resonance',
  resonance_open_app_on_mobile: 'Abrir la aplicación en el móvil',
  resonance_open_app_on_mobile_description: 'Para una mejor experiencia, te recomendamos usar la aplicación móvil.',
  resonance_open_app_on_mobile_button: 'Abrir la aplicación en el móvil',
};
